import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import ComputerIcon from 'views/ui/icons/computer';
import LocationIcon from 'views/ui/icons/location-icon';

import { Theme } from 'ui_system/theme';
import { TextField } from '../formStyles';

const Input = styled.input`
  ${TextField}
  padding-left: 40px;
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  position: relative;
  svg {
    margin: auto;
    position: absolute;
    top: 0;
    left: 10px;
    bottom: 0;
    width: ${(props) => props.iconWidth};
    fill: ${Theme.colors.iconsNotLinkedColor};
  }
`;

const Dropdown = styled.div`
  position: absolute;
  z-index: 100;
  top: 49px;
  left: 0px;
  height: auto;
  width: 100%;
  border: 1px solid #ccc;
  border-top: 1px solid #ccc;

  background-color: white;

  /* Prevent screen overlap */
  margin-bottom: 50px;
  overflow: auto;

  opacity: 1;
  transition: all 200ms ease-in;
  display: block;
  -webkit-animation: fadeInFromNone 0.3s ease-out;
  -moz-animation: fadeInFromNone 0.3s ease-out;
  -o-animation: fadeInFromNone 0.3s ease-out;
  animation: fadeInFromNone 0.3s ease-out;

  display: ${(props) => (props.open ? 'block' : 'none')};

  /* Mobile tweaks */
  @media (max-width: 700px) {
    width: 90vw;
  }
`;

const DropdownItem = styled.div`
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: ${Theme.colors.backgroundColor};
  }
`;

const PlacesInput = ({
  address: initialAddress = '',
  isOnlineSelected = false,
  placeholder,
  handleAddressChanged,
  handleGeocodeSelected,
}) => {
  const [address, setAddress] = useState(initialAddress);

  useEffect(() => {
    if (isOnlineSelected) {
      setAddress('');
    }
  }, [isOnlineSelected]);

  const handleChange = (_address) => {
    setAddress(_address);
    handleAddressChanged(_address);
  };

  const handleSelect = (_address) => {
    setAddress(_address);
    geocodeByAddress(_address).then((results) => {
      handleGeocodeSelected({
        address: results[0].formatted_address,
        placesAddress: _address,
        placeId: results[0].place_id,
      });
    });
  };

  return (
    <PlacesAutocomplete
      value={isOnlineSelected ? 'Online' : address}
      onChange={handleChange}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Container iconWidth={isOnlineSelected ? '22px' : '18px'}>
          <Input
            {...getInputProps({
              placeholder: placeholder || 'Enter a location',
            })}
            disabled={isOnlineSelected}
            data-testid="places-input"
          />
          {isOnlineSelected ? <ComputerIcon /> : <LocationIcon />}
          <Dropdown open={suggestions.length > 0}>
            {suggestions.map((suggestion) => {
              return (
                <DropdownItem {...getSuggestionItemProps(suggestion, {})}>
                  <span>{suggestion.description}</span>
                </DropdownItem>
              );
            })}
          </Dropdown>
        </Container>
      )}
    </PlacesAutocomplete>
  );
};

PlacesInput.propTypes = {
  address: PropTypes.string,
  isOnlineSelected: PropTypes.bool,
  placeholder: PropTypes.string,
  handleAddressChanged: PropTypes.func,
  handleGeocodeSelected: PropTypes.func,
};

export default PlacesInput;
